<!--nz-page-header *ngIf="children==null" [nzTitle]="'workflow.log.title'|translateTA" [nzSubtitle]="'workflow.log.subtitle'|translateTA"></nz-page-header-->

<nz-timeline class="timeline-custom">
  <ng-container *ngFor="let step of steps; let i = index">
    <nz-timeline-item nzColor="blue">
      <div class="timeline-custom-detail">
        <div>
          <strong>{{ step.name }}</strong> ({{ step.type }})
          <br />
          
          <nz-tag nzColor="blue">GUID: {{ step.guid }}</nz-tag>
          <nz-tag nzColor="purple">{{ step.dhStart }} → {{ step.dhEnd }}</nz-tag>
          <nz-tag *ngFor="let r of step.result" [nzColor]="getColor(r.success)">
            {{r.success ? ('SUCCESS'|translateTA) : ('FAIL'|translateTA) }}
          </nz-tag>

           <button nz-button nzType="link" (click)="step.expanded = !step.expanded" *ngIf="step.children?.length">
            <span *ngIf="step.expanded">[-] {{'workflow.log.collapse'|translateTA}}</span>
            <span *ngIf="!step.expanded">[+] {{'workflow.log.expand'|translateTA}}</span>
          </button>
        </div>
        <button nz-button nzType="link" (click)="openDetails(step)">{{'workflow.log.detail'|translateTA}}</button>
      </div>

      <!-- filhos recursivos -->
          
      <div class="timeline-custom-detail" *ngIf="step.expanded && step.children?.length">
          <div style="display: flex; flex-direction: column; width: 100%;margin-right: 12px;">
            <ng-container *ngFor="let group of step?.children;let i = index;">
              <nz-collapse nzBordered="true" class="card-board" style="margin-left: 12px;">
                <nz-collapse-panel nzHeader="{{'workflow.log.executionlist'|translateTA}} {{step.type}} [{{i}}]">
                  <webhook-log-detail [children]="group"></webhook-log-detail>
                </nz-collapse-panel>
              </nz-collapse>
            </ng-container>
          </div>
        </div>



    </nz-timeline-item>
  </ng-container>
</nz-timeline>


<nz-drawer
  [nzVisible]="detailsVisible"
  nzTitle="{{'log.result.step'|translateTA}}"
  nzPlacement="right"
  [nzWidth]="800"
  (nzOnClose)="detailsVisible=false">
    <div *nzDrawerContent class="log-result-container">
        <div class="toolbar-log-result">
          <h2><div class="text-block" nz-tooltip
          [nzTooltipTitle]="selectedStep?.name+ ' '+ ( selectedStep?.type )">{{ selectedStep?.name }} ({{ selectedStep?.type }})</div></h2>
         
          <nz-tag nzColor="purple">{{ selectedStep?.dhStart }} → {{ selectedStep?.dhEnd }}</nz-tag>
        </div>

        <h3>{{'log.execution.results'|translateTA}}</h3>
        <div class="log-filter-bar">
          <nz-tag  [nzChecked]="checkedFilterResult=='all'" nzMode="checkable"  (nzCheckedChange)="changeTagChecked($event,'all')">{{'ALL'|translateTA}}</nz-tag>
          <nz-tag  [nzChecked]="checkedFilterResult=='success'" nzMode="checkable" (nzCheckedChange)="changeTagChecked($event,'success')">{{'SUCCESS'|translateTA}}</nz-tag>
          <nz-tag  [nzChecked]="checkedFilterResult=='fail'" nzMode="checkable" (nzCheckedChange)="changeTagChecked($event,'fail')">{{'FAIL'|translateTA}}</nz-tag>
        </div>
        <nz-collapse *ngFor="let r of activeItems; let i = index">
            <nz-collapse-panel [nzHeader]="templateRef" >
              <json-viewer [json]="formatJSONViewer(r)" [startFold]="true" ></json-viewer>
            </nz-collapse-panel>
            <ng-template #templateRef let-panel="panel" >
                <div class="header-log-result-container">
                  <div>
                    <nz-tag nzColor="blue">{{i+1}}</nz-tag>
                    <nz-tag nzColor="purple"> {{ r.dhIni }} → {{ r.dhFin }}</nz-tag>
                  </div>
                  <nz-tag [nzColor]="getColor(r.success)"  (click)="$event.stopPropagation()" >
                              {{r.success ? ('SUCCESS'|translateTA) : ('FAIL'|translateTA) }}
                    </nz-tag>
                </div>
            </ng-template>
        </nz-collapse>

        <h3>{{'log.execution.parameters'|translateTA}}</h3>
        <nz-collapse>
            <nz-collapse-panel nzHeader="{{'log.outputparameters'|translateTA}}">
              <webhook-log-output [data]="formatJSON(selectedStep?.outputParameter)"></webhook-log-output>
            </nz-collapse-panel>
        </nz-collapse>
    </div>
</nz-drawer>

